import styled from "styled-components";
import {fontFamilies} from "theme/tokens";

/**
 * A quiet text action with a 14px icon: "Show QR code" and the Play control on the success cards' share row
 * (kitecorp/transferify-ui#3320, #3333). The label is the card's own ink, at the weight of the text around it;
 * only the icon carries the accent, so the row reads as two actions rather than two links. The visual height is
 * the text's and the touch target stays 44px, the way the success card's controls do it.
 */
export const InlineAction = styled.button`
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: 7px;
	flex: none;
	min-height: 30px;
	padding: 0;
	border: 0;
	background: transparent;
	color: ${({theme}) => theme.tokens.ink};
	font: 600 13px ${fontFamilies.sans};
	text-align: left;
	cursor: pointer;

	&::before {
		content: "";
		position: absolute;
		inset-inline: -6px;
		top: 50%;
		height: 44px;
		transform: translateY(-50%);
	}

	@media (hover: hover) {
		&:hover {
			text-decoration: underline;
			text-underline-offset: 3px;
		}
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}

	& > svg {
		width: 14px;
		height: 14px;
		flex: none;
		color: ${({theme}) => theme.tokens.blue};
		fill: currentColor;
	}
`;
